import axios from 'axios'

// Action Types
export const EPIC_ACTIONS = {
  FETCH_EPIC_DATA_REQUEST: 'FETCH_EPIC_DATA_REQUEST',
  FETCH_EPIC_DATA_SUCCESS: 'FETCH_EPIC_DATA_SUCCESS',
  FETCH_EPIC_DATA_FAILURE: 'FETCH_EPIC_DATA_FAILURE',
  CLEAR_EPIC_DATA: 'CLEAR_EPIC_DATA',
}

// Action Creators
export const fetchEpicDataRequest = () => ({
  type: EPIC_ACTIONS.FETCH_EPIC_DATA_REQUEST,
})

export const fetchEpicDataSuccess = (data, contactName) => ({
  type: EPIC_ACTIONS.FETCH_EPIC_DATA_SUCCESS,
  payload: { ...data, contactName },
})

export const fetchEpicDataFailure = (error) => ({
  type: EPIC_ACTIONS.FETCH_EPIC_DATA_FAILURE,
  payload: error,
})

export const clearEpicData = () => ({
  type: EPIC_ACTIONS.CLEAR_EPIC_DATA,
})

// Async Action Creator
export const fetchEpicData = (contactName, forceRefresh = false) => {
  return async (dispatch, getState) => {
    if (!contactName) {
      dispatch(clearEpicData())
      return
    }

    // Check if we already have data for this contact and don't force refresh
    const currentState = getState()
    const epicState = currentState.contacts.epic

    if (
      !forceRefresh &&
      epicState.data &&
      epicState.lastContactName === contactName &&
      !epicState.isLoading &&
      !epicState.error
    ) {
      return
    }

    dispatch(fetchEpicDataRequest())

    try {
      const response = await axios.get(`/epic/epic-data?contactName=${encodeURIComponent(contactName)}`)

      dispatch(fetchEpicDataSuccess(response.data, contactName))
    } catch (error) {
      dispatch(fetchEpicDataFailure(error.message || 'Failed to fetch Epic data'))
    }
  }
}
